import { render, staticRenderFns } from "./prosecute.vue?vue&type=template&id=578643c9&scoped=true"
import script from "./prosecute.vue?vue&type=script&lang=js"
export * from "./prosecute.vue?vue&type=script&lang=js"
import style0 from "./prosecute.vue?vue&type=style&index=0&id=578643c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578643c9",
  null
  
)

export default component.exports